<app-intro></app-intro>
<app-projects></app-projects>
<app-references></app-references>
